<template>
	<div class="keyboard">
		<div class="row">
			<span @click="() => sendKey('q')">Q</span>
			<span @click="() => sendKey('w')">W</span>
			<span @click="() => sendKey('e')">E</span>
			<span @click="() => sendKey('r')">R</span>
			<span @click="() => sendKey('t')">T</span>
			<span @click="() => sendKey('y')">Y</span>
			<span @click="() => sendKey('u')">U</span>
			<span @click="() => sendKey('i')">I</span>
			<span @click="() => sendKey('o')">O</span>
			<span @click="() => sendKey('p')">P</span>
		</div>
		<div class="row">
			<span @click="() => sendKey('a')">A</span>
			<span @click="() => sendKey('s')">S</span>
			<span @click="() => sendKey('d')">D</span>
			<span @click="() => sendKey('f')">F</span>
			<span @click="() => sendKey('g')">G</span>
			<span @click="() => sendKey('h')">H</span>
			<span @click="() => sendKey('j')">J</span>
			<span @click="() => sendKey('k')">K</span>
			<span @click="() => sendKey('l')">L</span>
		</div>
		<div class="row">
			<span @click="() => sendKey('z')">Z</span>
			<span @click="() => sendKey('x')">X</span>
			<span @click="() => sendKey('c')">C</span>
			<span @click="() => sendKey('v')">V</span>
			<span @click="() => sendKey('b')">B</span>
			<span @click="() => sendKey('n')">N</span>
			<span @click="() => sendKey('m')">M</span>
			<span @click="() => sendKey('')" class="delete">◁</span>
		</div>
		
	</div>
</template>

<script>
export default {
	props: ['color'],
	methods: {
		sendKey(letter) {
			this.$emit('input',{
				letter: letter,
				index: this.$store.state.currentKey
			});
		}
	}
}
</script>
<style scoped lang="scss">
	.keyboard {
		width: 95%;
		margin: auto;
		margin-top: px(25);
		
		.row {
			width: 100%;
			display: flex;
			justify-content: center;
			span {
				margin: px(2.5);
				min-width: px(50);
				height: px(50);
				padding: px(10);
				display: flex;
				justify-content: center;
				align-items: center;
				border-radius: px(4);
				background: #fff;
				cursor: pointer;
				color: $mondadori-blue;
				@include breakpoint(s) {
					height: px(50);
					width: px(30);
					min-width: px(35);
				}
				@include breakpoint(xs) {
					height: px(55);
				}
				&:hover {
					background: $dark-blue;
					color: #fff;
				}

				&.delete {
					background: transparent;
					border: px(4) solid #fff;
					color: #fff;

					&:hover {
						color: $mondadori-blue;
						background: #fff;
					}
				}
				&::selection {
					background: transparent;
				}
			}
		}
	}
</style>